import { classes } from 'html-classes';

import Badge from '~/components/Badge/Badge';

import styles from './DiscountBadge.module.scss';

type Props = {
  currentPrice: number;
  oldPrice: number;
  classNames?: string;
  size?: 'xxs' | 'xs' | 's' | 'm';
  theme: 'primary' | 'secondary';
};

const DiscountBadge = ({
  currentPrice,
  oldPrice,
  classNames,
  size,
  theme,
}: Props) => {
  if (currentPrice > oldPrice) {
    return null;
  }

  let value = 100 - Math.round((currentPrice * 100) / oldPrice);
  if (value < 1) {
    value = 1;
  }

  return (
    <Badge
      size={size}
      theme={theme}
      className={classes([styles.root, classNames])}
    >
      {`-${value}%`}
    </Badge>
  );
};

export default DiscountBadge;
